export default {"src":"/_next/static/media/lighting.cca6ad90.svg","height":29,"width":26,"blurWidth":0,"blurHeight":0};